import { render, staticRenderFns } from "./MHeader.vue?vue&type=template&id=32a81624&scoped=true&"
import script from "./MHeader.vue?vue&type=script&lang=ts&"
export * from "./MHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MHeader.vue?vue&type=style&index=0&id=32a81624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a81624",
  null
  
)

export default component.exports